import React from 'react';
import { Search } from 'lucide-react';

// T0 — Barre de recherche unifiée (dark-mode natif).
export const SearchBar = ({ value, onChange, placeholder = 'Rechercher…', className = '' }) => (
  <div className={`relative ${className}`}>
    <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" />
    <input
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      className="w-full pl-10 pr-4 py-2 bg-gray-50 dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg text-gray-800 dark:text-gray-100 placeholder-gray-400 focus:ring-2 focus:ring-blue-500 focus:outline-none transition-shadow"
    />
  </div>
);

export default SearchBar;
